import { render, staticRenderFns } from "./AutomationActionInput.vue?vue&type=template&id=2936dba5&scoped=true&"
import script from "./AutomationActionInput.vue?vue&type=script&lang=js&"
export * from "./AutomationActionInput.vue?vue&type=script&lang=js&"
import style0 from "./AutomationActionInput.vue?vue&type=style&index=0&id=2936dba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936dba5",
  null
  
)

export default component.exports